import { render, staticRenderFns } from "./managerChooseProductType.vue?vue&type=template&id=e9488312&scoped=true"
import script from "./managerChooseProductType.vue?vue&type=script&lang=js"
export * from "./managerChooseProductType.vue?vue&type=script&lang=js"
import style0 from "./managerChooseProductType.vue?vue&type=style&index=0&id=e9488312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9488312",
  null
  
)

export default component.exports